import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { hideNavBar: false },
  },
  {
    path: "/adeia",
    name: "Adeia",
    component: () => import("../views/AdeiaPage.vue"),
    meta: { hideNavBar: false },
  },
  {
    path: "/xj77ref",
    name: "admin",
    component: () => import("../views/ControlPanel.vue"),
    meta: { hideNavBar: true },
  },
  {
    path: "/quran",
    name: "Quran",
    component: () => import("../views/Quran/QuranPage.vue"),
    meta: { hideNavBar: false },
  },
  {
    path: "/ahadyth",
    name: "Ahadyth",
    component: () => import("../views/AhadythPage.vue"),
    meta: { hideNavBar: false },
  },
  {
    path: "/eibarat",
    name: "Eibarat",
    component: () => import("../views/EibaratPage.vue"),
    meta: { hideNavBar: false },
  },
  //
  {
    path: "/quran/mp3",
    name: "mp3",
    component: () => import("../views/Quran/QuranMp3.vue"),
    meta: { hideNavBar: false },
  },
  {
    path: "/quran/text",
    name: "text",
    component: () => import("../views/Quran/QuranText.vue"),
    meta: { hideNavBar: false },
  },
  {
    path: "/quran/mp3/:id",
    name: "quran-player",
    component: () => import("../views/Quran/QuranPlayer.vue"),
    meta: { hideNavBar: true },
  },
  {
    path: "/quran/text/:link",
    name: "quran-page",
    component: () => import("../views/Quran/QuranContent.vue"),
    meta: { hideNavBar: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
